import './App.css';

import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Homepage from './pages/homepage/homepage.component.jsx';
import TermsPage from './pages/terms/terms.page.jsx';
import PrivacyPage from './pages/privacy/privacy.page.jsx';


function App() {
  return <BrowserRouter>
      <Routes>
        <Route path="/terms" element={<TermsPage/>} />
        <Route path="/privacy" element={<PrivacyPage/>} />
        <Route path="/" element={<Homepage/>} />
      </Routes>
    </BrowserRouter>
}

export default App;
